import React, { Component, Fragment, useEffect } from 'react';
import { Navigationmenu } from '../components';
import CircularProgress from '@material-ui/core/CircularProgress'
import ReactSession from '../reactclient.js';
import { withRouter } from 'react-router-dom';
import circulargridimage from '../gallery/gridloader.gif';
import Wrappercontainer from "../components/Wrappercontainer"
import { fnPostapiResponse, fnGETapiResponse, Fnencryption } from '../APICall';
import DatePicker from 'react-datepicker';
import moment, { max } from 'moment';
// import 'react-datepicker/dist/react-datepicker.css';

import Footer from '../components/Footer';




import {
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Divider,
    Select,
    InputLabel,
    MenuItem,
    Popover,
    Tabs,
    Tab,
    DialogActions,
    withStyles,
    Slide,
    Dialog,
    AppBar,
    TableFooter, ListItemText, FormLabel, Checkbox
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from "@material-ui/core/Toolbar";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Labelcontrol from "../components/Labelcontrol";

import { FileCopy, Refresh, Add, Delete, Edit } from '@material-ui/icons';


import {
    SearchOutlined,
    ArrowDropDown,
    Publish,
    NoteAdd,
    ArrowDropUp,
    InsertDriveFileOutlined,
    QueryBuilderTwoTone
} from '@material-ui/icons';
import {
    DataGrid, GridToolbarExport,
    GridToolbarContainer
} from '@material-ui/data-grid';

import {
    ALTERNATEROW_BACKGROUND_COLOR,
    BLUE_COLOR, LIGHTGRAY_COLOR,
    MODIFIEDBLACK,
    PINK_COLOR,
    PROTECT_GREEN,
    RED_COLOR,
    VIBRANT_GREEN, DARKGREEN_COLOR,
    LIGHTGREEN_COLOR
} from "../constants";
import Switch from '@material-ui/core/Switch';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import List from "@material-ui/core/List";
import renderIf from 'render-if';
import { Redirect } from "react-router-dom";
import axios from "axios"
import { IdleTimeOutModal } from '../components/Logoutmodal';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import { ExportExcel } from './ExportExcel';

const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        backgroundColor: 'white',
        height: 3
    },
}, { index: 1 })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
const SomeComponent = withRouter(props => <SearchPage {...props} />);
const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'white',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        '&:focus': {
            opacity: 1
        }
    },
}, { index: 1 }))((props) => <Tab disableRipple {...props} />);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
function ClientList() {
    return (
        <GridToolbarContainer>
            {/* <GridToolbarExport /> */}
        </GridToolbarContainer>
    );
}
export default class SearchPage extends Component {
    state = {
        tablebuffer: [],
        pages: 0,
        current: 1,
        records: 0,
        pageSize: 10,
        showPager: false,
        SOURCE: "",
        FNAME: "",
        IsWindowsAuth: "",
        SNAME: "",
        SNAMElabel: "",
        NIC: "",
        NICselectedlabel: "Business Registration Number",
        Reportdate: "",
        DBUserName: "",
        DBPassword: "",
        DBSource: "",
        DBProvider: "",
        test: false,
        CMLISLODING: false,
        pagesObj: [],
        selectedUser: "",
        newOBJ: [],
        selectedPass: "",
        ClientType: [],
        CompanyType: [],
        NATIONALITY: [],
        GENDER: [],
        country: [],
        SelectedClientType: "",
        SelectedCompany: 'SGL',
        SelectedClientName: "",
        selectedPassDROP: "",
        ispassdrp: false,
        isclntIndv: false,
        lblnationality: "",
        amlgender: "M",
        selectedOption: true,
        caseid: "",
        selectedCountry: "",
        ismandatory: false,
        pageloadingdata: 0,
        nicvaliderror: "",
        todayDate: "",
        displayastric: "none",
        displayclose: "none",
        redirect: false,
        direction: "SearchPage",
        showModal: false,
        isforeignSwitch: false,
        isforeignSwitchChecked: false,
        showViewer: false,
        isdisplayswitch: "block",
        displayForeign: "block",
        PEPLISTTYPE: "PEP",
        processedValues: [],
        columns: [],
        alldata: [],
        exportbuttonbackcolor: LIGHTGRAY_COLOR,
        ExportButtonDisabled: true
    }


    handleSomeDateChange(e) {
        if (new Date(e.target.value) > new Date()) {
            alert("Report Date can not be Greater then Today's Date")
            this.setState({ Reportdate: this.state.todayDate })
        }
        else {


            if (e.target.value == "")
                alert("Please select a valid date")
            else
                this.setState({ Reportdate: e.target.value })
        }
    }

    componentDidMount() {
        var date = new Date()
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
        var date1 = date.getDate() < 10 ? "0" + (date.getDate()) : date.getDate()
        var CMLSELECTEDATE = date.getFullYear() + "-" + month + "-" + date1
        this.state.todayDate = CMLSELECTEDATE
        this.setState({ Reportdate: CMLSELECTEDATE })
        this.state.selectedUser = sessionStorage.getItem('username')
        this.state.selectedPass = sessionStorage.getItem('password')
        this.state.IsWindowsAuth = sessionStorage.getItem('IsWindowsAuth')
    }
    padValue = (value) => {
        return (value < 10) ? "0" + value : value;
    }
    convertDateStringintoYYYYMMDD(date) {
        console.log(date)
        if (date == "" || date ==null)
            return date
        else
            return date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 8);
    }
    isEven(n) {
        return n % 2 == 0;
    }
    cleardetails() {
        this.state.alldata = []
        this.renderpages()
        this.setState({
            CMLISLODING: false,
            exportbuttonbackcolor: LIGHTGRAY_COLOR,
            ExportButtonDisabled: true
        })
    }
     fngetcmpFullname(cmpcode) {
        if (cmpcode == "SGL")
            return "SWAN GENERAL"
        if (cmpcode == "SLL")
            return "SWAN LIFE"
        if (cmpcode == "SPL")
            return "SWAN PENSIONS"
        if (cmpcode == "SSL")
            return "SWAN SECURITIES"
        if (cmpcode == "SWL")
            return "SWAN WEALTH"
        if (cmpcode == "SSR")
            return "SWAN SSR"
    }
    fnGetRBMClientlist(reportdate, companyname) {
        // if(companyname == "SSR" ||companyname == "SPL" || companyname == "SSL" )
        // {
        //     alert("No data found")
        //     this.state.alldata = []
        //     this.renderpages()
        // }else{
        var cmpname = this.fngetcmpFullname(companyname)
        var cmpcode = companyname
        this.setState({
            alldata: [],
            CMLISLODING: true
        })
        var data =
        {
            "MAPIURL": "" + process.env.REACT_APP_SOURCE_URL + "",
            "MAPINAME": 'GetRBMClientlist',
            "MAPIPORT": process.env.REACT_APP_MPORT,
            "body": {
                "dt": reportdate.replace(/-/g, ''),
                "company_name": cmpname,
                "cmp_Code":cmpcode

            }
        }
        console.log("body", data)
        fnPostapiResponse(process.env.REACT_APP_SOURCE_URL_MIDDLEWARE, 'postApiMiddleWare', data, process.env.REACT_APP_PORT_MIDDLEWARE).then((response) => {
            var rowObj = response.data
            console.log(rowObj)
            if(rowObj['compDetails']!=undefined)
            {
            var newdata = rowObj['compDetails'][0]
            
            for (var i = 0; i < newdata.length; i++) {
                newdata[i]['S_DOB'] = this.convertDateStringintoYYYYMMDD(newdata[i]['S_DOB'])
                 //newdata[i].decimal = i + 0.003
            }
            this.setState({ alldata: newdata })
            console.log(newdata)
            this.renderpages()
            this.setState({
                CMLISLODING: false,
                exportbuttonbackcolor: BLUE_COLOR,
                ExportButtonDisabled: false
            })}
            else{
                alert(rowObj)
                this.state.alldata = []
                this.renderpages()
                this.setState({
                    CMLISLODING: false
                })
            }
        }).catch(e => console.log(e));
    }
    renderpages() {
        this.state.records = this.state.alldata.length;
        this.state.pages = parseInt(this.state.records / this.state.pageSize)
        if (this.state.records % this.state.pageSize > 0)
            this.state.pages++;
        this.state.showPager = this.state.pages > 1
        this.pageChange(0)
    }
    pageChange(number) {
        this.state.current = number;
        var data = this.state.alldata.slice(this.state.current * this.state.pageSize, (this.state.current + 1) * this.state.pageSize);
        this.setState({ tablebuffer: data })

        this.state.pagesObj = [];
        if (this.state.pages < 10) {
            for (var i = 0; i < this.state.pages; i++)
                this.state.pagesObj.push(i);
        }
        else {
            var min = this.state.current - 5;
            var max = this.state.current + 5;
            if (min < 0)
                min = 0;
            if (max > this.state.pages)
                max = this.state.pages;
            if (max - min > 10) {
                min = this.state.current - 5;
                max = this.state.current + 5;
            }
            if (min > 0)
                this.state.pagesObj.push(0);
            for (var i = min; i < max; i++)
                this.state.pagesObj.push(i);
            if (max < this.state.pages - 1)
                this.state.pagesObj.push(this.state.pages - 1);

        }
    }

    render() {
        return (

            <Fragment>
                {this.state.redirect &&
                    <Redirect to={this.state.direction} />
                }
                <Navigationmenu selectedMenu={'AMLSEARCH'} />

                <IdleTimeOutModal
                    showModal={this.state.showModal}
                    handleClose={this.handleClose}
                    handleLogout={this.handleLogout}

                />
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{ marginTop: 35 }}
                >
                    <Paper elevation={2} style={{ minHeight: 100, width: '90%', borderRadius: 6 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <div style={{ minHeight: 100, width: '98%', borderRadius: 6 }}>

                                <Grid container spacing={2} >
                                    <Grid item xs={11}>
                                        <div style={{
                                            display: 'flex',
                                            marginBottom: 20,
                                            marginTop: 60
                                        }}>
                                            <Typography style={{ borderWidth: 0, color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', fontSize: 25, paddingLeft: 1 }}>
                                                Compliance List</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/*FILTER DROPDOWNS*/}
                                <Grid container spacing={3} style={{ marginBottom: 30 }}>
                                    <Grid item xs={1} style={{ fontSize: "15px", fontFamily: 'Globerbold', color: BLUE_COLOR }}  >
                                        COMPANY
                                    </Grid>
                                    <Grid item xs={2}>

                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.SelectedCompany}
                                            onChange={e => this.setState({ SelectedCompany: e.target.value },
                                                
                                                )}
                                        >
                                            <MenuItem value='SGL'>SWAN GENERAL</MenuItem>
                                            <MenuItem value='SLL'>SWAN LIFE</MenuItem>
                                            <MenuItem value='SPL'>SWAN PENSIONS</MenuItem>
                                            <MenuItem value='SSL'>SWAN SECURITIES</MenuItem>
                                            <MenuItem value='SWL'>SWAN WEALTH</MenuItem>
                                            <MenuItem value='SSR'>SWAN SSR</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={2} style={{ fontSize: "15px", fontFamily: 'Globerbold', color: BLUE_COLOR }}  >
                                        REPORT DATE
                                    </Grid>
                                    <Grid item xs={2} style={{ marginLeft: '-80px' }}>
                                        <TextField fullWidth id="date" disabled={this.state.isclntIndv} label=""
                                            type="date"
                                            value={this.state.Reportdate}
                                            className="form-control"
                                            variant="outlined"
                                            onChange={e => this.handleSomeDateChange(e)}
                                            inputProps={{
                                                max: "" + this.state.todayDate + "",
                                                style: { fontFamily: 'Globerbold' }
                                            }}
                                            InputLabelProps={{ style: { fontFamily: 'Globerbold', color: BLUE_COLOR } }}
                                        />
                                    </Grid>



                                    <Grid item xs={2}>

                                        <Select fullWidth
                                            variant={'outlined'}
                                            value={this.state.PEPLISTTYPE}
                                            onChange={e => this.setState({ PEPLISTTYPE: e.target.value })}
                                        >
                                            <MenuItem value={"PEP"}>PEP</MenuItem>
                                        </Select>
                                    </Grid>
                                    <Grid item xs={3} >
                                        <Button variant={'text'} onClick={(e) => this.fnGetRBMClientlist(this.state.Reportdate, this.state.SelectedCompany)} style={{ color: 'white', marginLeft: '2px', fontFamily: 'Globerbold', backgroundColor: VIBRANT_GREEN, width: '50%', fontSize: 16 }}>
                                            generate list
                                        </Button>
                                        <Button variant={'text'} onClick={(e) => this.cleardetails()} style={{ color: 'white', fontFamily: 'Globerbold', marginLeft: "10px", backgroundColor: BLUE_COLOR, width: '40%', fontSize: 16 }}>
                                            CLEAR
                                        </Button>

                                    </Grid>
                                </Grid>

                                <Grid container spacing={2} style={{ marginTop: 10 }}>
                                    <TableContainer>
                                        <Table aria-label="simple table">
                                            <TableHead style={{ backgroundColor: 'rgba(241,241,241,1.0)' }}>
                                                <TableRow>
                                                    <TableCell style={{ width: '80px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Title</TableCell>
                                                    <TableCell style={{width: '200px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Surname / Company
                                                    </TableCell>
                                                    <TableCell style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">forname</TableCell>
                                                    <TableCell style={{ borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">NIC</TableCell>
                                                    <TableCell style={{ width: '130px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">COMPANY</TableCell>
                                                    <TableCell style={{ width: '100px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">CLIENTID</TableCell>
                                                    <TableCell style={{ width: '100px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">DOB</TableCell>
                                                    <TableCell style={{ width: '100px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">PEP_CD</TableCell>
                                                    <TableCell style={{ width: '95px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">DATASRC</TableCell>
                                                    <TableCell style={{ width: '150px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">RBMProfile</TableCell>
                                                    <TableCell style={{ width: '150px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">CRPProfile</TableCell>
                                                    <TableCell style={{ width: '150px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Product</TableCell>
                                                    <TableCell style={{ width: '200px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">Nationality_Country</TableCell>
                                                    <TableCell style={{ width: '200px', borderWidth: 1, color: MODIFIEDBLACK, textTransform: 'uppercase', fontFamily: 'Globerbold' }} align="center">reg_address_country</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {!this.state.CMLISLODING ?
                                                    this.state.tablebuffer.map((obj, index) => {

                                                        var rowbackgroundColor = 'white';
                                                        if (this.isEven(index)) { rowbackgroundColor = ALTERNATEROW_BACKGROUND_COLOR; }

                                                        if (this.state.ishovered && this.state.hoverindex == index) { rowbackgroundColor = LIGHTGRAY_COLOR }
                                                        return (

                                                            <TableRow style={{ cursor: 'pointer' }} key={index}>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.TITLE}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.S_SURNAME}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.S_FIRSTNAME}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.S_NIC}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.COMPANY}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.CLIENTID}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.S_DOB}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.PEP_CD}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.DATASRC}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.RBMPROFILE}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.CRPPROFILE}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.PRODUCT}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.NATIONALITY_COUNTRY}</TableCell>
                                                                <TableCell style={{ borderWidth: 1, whiteSpace: 'unset', color: BLUE_COLOR, textTransform: 'uppercase', fontFamily: 'Globerbold', backgroundColor: rowbackgroundColor }} align="center">{obj.REG_ADDRESS_COUNTRY}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                    : <td style={{ marginLeft: "500px", height: "150px" }}>
                                                        <img style={{ width: "100px" }} src={circulargridimage} alt="circulargridimage" />;
                                                    </td>}
                                            </TableBody>
                                        </Table>
                                        <div style={this.state.showPager ? { height: 60, marginLeft: "600px", color: MODIFIEDBLACK, fontSize: "15px", textTransform: 'uppercase', fontFamily: 'Globerbold', wordBreak: "break-word" } : { display: "none" }} >
                                            {
                                                this.state.pagesObj.map((obj, index) => {
                                                    return (
                                                        <span style={{ padding: "0 3px", cursor: "pointer" }}>
                                                            <a style={this.state.current == obj ? { fontWeight: 'bold', color: BLUE_COLOR, fontSize: "30px" } : {}} onClick={() => this.pageChange(obj)} >{obj + 1}</a>
                                                        </span>
                                                    )
                                                })
                                            }
                                        </div>
                                    </TableContainer>
                                </Grid>
                                {/* <Footer></Footer> */}
                                <br></br>
                                <Divider></Divider>
                                <Grid item xs style={{ marginTop: '10px' }}>
                                    &nbsp;&nbsp;
                                    {/* <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: BLUE_COLOR, width: '121px', height: '40px' }}>
                                        Print Result
                                    </Button> */}
                                    <ExportExcel
                                        disabled={this.state.ExportButtonDisabled}
                                        backcolor={this.state.exportbuttonbackcolor}
                                        csvData={this.state.alldata} fileName={this.state.SelectedCompany + '_' + this.state.PEPLISTTYPE + "_" + this.state.Reportdate.replace(/-/g, '')} />
                                    &nbsp;&nbsp;
                                </Grid>
                                {/* <Footer></Footer> */}
                                <br></br>
                            </div>
                        </Box>
                    </Paper>
                </Box>
            </Fragment>
        )
    }
}